export default function Header({ details, user }) {
  if (!user) {
    return null
  }

  const { name, email } = user
  const { timezone, currencyCode } = details || {}

  return <div>
    {name} <small>({email})</small>
    <div>
      <em>{timezone}</em>
    </div>
    <div>
      <em>{currencyCode}</em>
    </div>
  </div>
}

